export default __webpack_public_path__ + "static/automotive4-f039b47961b74f53937c2319e3653dc7.jpeg";